import { ApiData } from '../types/rest';

export const useScene = (data: ApiData, setSceneDataById: (id: number) => void) => {
	const setScene = (id: string) => {
		const sceneData = data.level_up?.scenes;
		if (!sceneData) {
			return;
		}

		if (sceneData[id]) {
			setSceneDataById(sceneData[id]);
		} else {
			setSceneDataById(0);
		}
	};

	return { setScene };
};
